export const locations = [
  {
    id: 'palmares',
    title: 'Palmares',
    position: { lat: 10.05599871915672, lng: -84.44095378225704 },
    description: '100m norte y 50m sur del Super Brayca, Alajuela Province, Palmares',
    phone: '+506 6280-3430',
    waze: 'https://waze.com/ul?ll=10.05599871915672,-84.44095378225704&navigate=yes',
  },
  {
    id: 'escazu',
    title: 'Escazú',
    position: { lat: 9.953177923523576, lng: -84.15809639938378 },
    description: 'Guachipelin de Escazú ,San José, Costa Rica Ofibodegas Capri.',
    phone: '+506 6045-8068',
    waze: 'https://waze.com/ul?ll=9.953177923523576,-84.15809639938378&navigate=yes',
  },
    {
    id: 'pinares',
    title: 'Pinares',
    position: { lat: 9.911711085346207, lng: -84.02105291850673 },
    description: 'Plaza Mabinsa Sur, Del Servicentro la galera 800 mts este Frente a oficinas de Mabinsa local#2 Plaza Comercial.',
    phone: '+506 6025-5556',
    waze: 'https://waze.com/ul?ll=9.911711085346207,-84.02105291850673&navigate=yes',
  },
    {
    id: 'Uvita',
    title: 'Uvita',
    position: { lat: 9.17328362339749, lng: -83.74131574585539},
    description: 'Diagonal al servicentro Bahia Ballena o, 230m Oeste del BCR, Provincia de Puntarenas, Uvita, 6050.',
    phone: '+506 6485-0574',
    waze: 'https://waze.com/ul?ll=9.17328362339749,-83.74131574585539&navigate=yes',
  },
    {
    id: 'guanacaste',
    title: 'Guanacaste',
    position: { lat: 10.324709282325474, lng: -85.8005034302742 }, 
    description: '100 mts del Cementerio de Santa Rosa, Provincia de Guanacaste, Tamarindo, 50309',
    phone: '+506 6005-5845',
    waze: 'https://waze.com/ul?ll=10.324709282325474,-85.8005034302742&navigate=yes',
  },{
    id: 'jaco',
    title: 'Jaco',
    position: { lat: 9.62037794959212, lng: -84.63447424585272 },
    description: 'Pastor Diaz Ave, Puntarenas Province, Jaco, Barrio Santa Lucía, 61101',
    phone: '+506 6059-6983',
    waze: 'https://waze.com/ul?ll=9.62037794959212,-84.63447424585272&navigate=yes',
  },{
    id: 'Paseo de las Flores',
    title: 'Paseo de las Flores',
    position: { lat: 9.984996, lng: -84.111242 },
    description: 'Mall Paseo de las Flores, Heredia, Costa Rica, Local L28A L28B',
    phone: '+506 6053-7941',
    waze: 'https://waze.com/ul?ll=9.984996,-84.111242&navigate=yes',
  },
];
